import React from "react";
import { useNavigate } from "react-router-dom";
import "./LegalSupport.css";

// Mirrored structured links matching the source reference dictionary block exactly[cite: 14]
const MENU_DATA = {
  MedicalReferencesFrameworks: {
    title: "Medical References & Frameworks",
    items: [
      {
        id: "who_nurturing",
        label: "WHO Nurturing Care Framework (2018)",
        url: "https://www.who.int/teams/maternal-newborn-child-adolescent-health-and-ageing/child-health/nurturing-care",
      },
      {
        id: "nelson_pediatrics",
        label: "Nelson Textbook of Pediatrics, 22nd Ed. (2024)",
        url: "https://scholar.google.com/citations?user=gEesh-UAAAAJ",
      },
      {
        id: "iap_ecd_module",
        label: "IAP ECD Nurturing Care Training Module",
        url: "https://indianpediatrics.net/oct2021/oct-962-969.htm",
      },
      {
        id: "paediatrician_special_needs",
        label: "A Paediatrician's Approach to a Child with Special Needs (2022)",
        url: "https://books.ipinnovative.com/books/202/a-paediatricians-approach-to-a-child-with-special-needs",
      },
    ],
  },
  privacySection: {
    title: "Privacy & Permissions",
    items: [
      {
        id: "consent_management",
        label: "Manage Child Permissions",
        route: "/child-consent-management", // Adjust this to match your actual React Router path
        requiresParent: true,
      },
    ],
  },
  supportSection: {
    title: "Support",
    items: [
      {
        id: "support",
        label: "Help & Support",
        url: "https://smile2steps.com/help",
      },
    ],
  },
  legalSection: {
    title: "Legal & Compliance",
    items: [
      {
        id: "terms",
        label: "Terms of Service",
        url: "https://smile2steps.com/terms",
      },
      {
        id: "privacy",
        label: "Privacy Policy",
        url: "https://smile2steps.com/privacy",
      },
      {
        id: "accessibility",
        label: "Accessibility Statement",
        url: "https://smile2steps.com/accessibility",
      },
      {
        id: "grievance",
        label: "Grievance Officer (India)",
        url: "https://smile2steps.com/grievance",
      },
    ],
  },
};

// Accept userRole as a prop here
const LegalSupport = ({ userRole }) => {
  const navigate = useNavigate();

  const handleItemPress = (item) => {
    // Navigate if it's an internal screen routing
    if (item.route) {
      navigate(item.route);
      return;
    }

    // Opens compliance and framework links in a safe, sandboxed external browser tab[cite: 14]
    if (item.url) {
      window.open(item.url, "_blank", "noopener,noreferrer");
    }
  };

  const renderSection = (section) => {
    // Filter items based on the userRole prop
    const visibleItems = section.items.filter((item) => {
      if (item.requiresParent && userRole !== "parent") {
        return false;
      }
      return true;
    });

    if (visibleItems.length === 0) return null;

    return (
      <div key={section.title} className="legal-section-block">
        <h2 className="legal-section-title">{section.title}</h2>
        <div className="legal-section-panel">
          {visibleItems.map((item) => (
            <button
              key={item.id}
              className="legal-row-card"
              onClick={() => handleItemPress(item)}
              type="button"
            >
              <span className="legal-row-text">{item.label}</span>
              <span className="legal-chevron">➔</span>
            </button>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="legal-page-wrapper">
      <div className="legal-hero-card">
        <header className="legal-header-row">
          <h1 className="legal-main-heading">Legal & Support</h1>
        </header>

        <main className="legal-scroll-container">
          {renderSection(MENU_DATA.MedicalReferencesFrameworks)}
          {renderSection(MENU_DATA.privacySection)}
          {renderSection(MENU_DATA.supportSection)}
          {renderSection(MENU_DATA.legalSection)}
        </main>
      </div>
    </div>
  );
};

export default LegalSupport;